import React, { useState, useEffect, useRef } from 'react';
import BASE_URL from "../../../../config/config";
import { useNavigate, useLocation } from 'react-router-dom';
import JobDocumentService from "../../Controller/JobDocumentController";

import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import JobService from "../../Controller/JobController";
import HelpSite from "../../../Common/HelpLink";
function JobDocumentPage({ JobID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    JobID = localStorage.getItem('JobID');
    const [JobDocuemntList, setJobDocumentData] = useState([]);


    const CompanyID = localStorage.getItem("CompanyID");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const tableRef = useRef();
    const [isClosed, SetIsClosed] = useState("0");
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    const fetchJobDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(redirectCallback, JobID);
                SetIsClosed(jobDetail[0].IsCompleted);

            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    useEffect(() => {
        SetIsClosed(localStorage.getItem("Closed"));
        fetchJobDetail();
        if (JobDocuemntList.length > 0) {
            initDataTable();
        }
    }, [JobDocuemntList, localStorage.getItem("Closed")]);

    const fetchJobSignatures = async (JobID) => {
        try {

            const data = await JobService.GetSignatureByJob(JobID)
            setJobDocumentData(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    useEffect(() => {
        if (JobID > 0) {
            fetchJobSignatures(JobID);
        }
        else {
            setJobDocumentData([])
        }
    }, [JobID]);
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px", marginTop: "10px" }}>
                <div className="col-sm-12">
                    <div className="table-responsive">
                        <div className='divTable'>

                            <div style={{ maxHeight: "460px", overflow: "auto" }}>
                                <table ref={tableRef} className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Attached File</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {JobDocuemntList.map((signat) => (
                                            <tr key={signat.ID}>
                                                <td className="no-wrap">{signat.DisplayName}</td>

                                                <td><a href={`${BASE_URL}/${signat.Signature}`} target="_blank" rel="noopener noreferrer">Open File</a></td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default JobDocumentPage;
